'use client';

import React from 'react';
import ImageContentSlider, {ImageSliderProps} from 'components/commercetools-ui/organisms/content/image-content-slider';
import { TasticProps } from 'frontastic/tastics/types';


const ImageContentSliderTastic  = ({ data }: TasticProps<ImageSliderProps>) => {
  return <ImageContentSlider data={data?.data?.dataSource} />;
};

export default ImageContentSliderTastic;